import axios from "../axiosPlugin.js";

// News
export const getCategoryListService = data => {
  return axios({
    url: "/api/news/categoryList",
    method: "get",
    data: { data }
  });
};

export const getNewsListService = data => {
  return axios({
    url: "/api/news/list",
    method: "get",
    data: { data }
  });
};

export const updatePublishStatusService = data => {
  const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
  return axios({
    url: `/api/news/updatePublishStatus?${_data}`,
    method: "put",
    data: { data }
  });
};

export const updateNewsService = data => {
  return axios({
    url: "/api/news/update",
    method: "put",
    data: { data }
  });
};

export const getNewsDetailService = data => {
  return axios({
    url: `/api/news/detail/${data.id}`,
    method: "get",
    data: {}
  });
};

export const createNewsService = data => {
  return axios({
    url: "/api/news/create",
    method: "post",
    data: { data }
  });
};

export const deleteNewsService = data => {
  return axios({
    url: `/api/news/delete/${data.id}`,
    method: "delete",
    data: {}
  });
};

// Custom Page
export const getCustomisedListService = data => {
  return axios({
    url: "/api/customised/list",
    method: "get",
    data: { data }
  });
};

export const createCustomService = data => {
  return axios({
    url: "/api/customised/create",
    method: "post",
    data: { data }
  });
};

export const getCustomDetailService = data => {
  return axios({
    url: `/api/customised/detail/${data.id}`,
    method: "get",
    data: {}
  });
};

export const updateCustomService = data => {
  return axios({
    url: "/api/customised/update",
    method: "put",
    data: { data }
  });
};

export const deleteCustomService = data => {
  return axios({
    url: `/api/customised/delete/${data.id}`,
    method: "delete",
    data: { data }
  });
};

// PriceTable
export const getPriceTableListService = data => {
  return axios({
    url: "/api/priceTable/list",
    method: "get",
    data: { data }
  });
};

export const createPriceTableService = data => {
  return axios({
    url: "/api/priceTable/create",
    method: "post",
    data: { data }
  });
};

export const getPriceTableDetailService = data => {
  return axios({
    url: `/api/priceTable/detail/${data.id}`,
    method: "get",
    data: {}
  });
};

export const updatePriceTableService = data => {
  return axios({
    url: "/api/priceTable/update",
    method: "put",
    data: { data }
  });
};

export const deletePriceTableService = data => {
  return axios({
    url: `/api/priceTable/delete/${data.id}`,
    method: "delete",
    data: {}
  });
};

// WebsiteSettingGuide
export const getWebsiteSettingGuideService = data => {
  return axios({
    url: "/api/websiteGuideSetting/current",
    method: "get",
    data: { data }
  });
};

export const updateWebsiteSettingGuideService = data => {
  return axios({
    url: "/api/websiteGuideSetting/update",
    method: "put",
    data: { data }
  });
};

// CompanyInfo
export const getCompanyInfoService = data => {
  return axios({
    url: "/api/companyInfo/current",
    method: "get",
    data: { data }
  });
};

export const updateCompanyInfoService = data => {
  return axios({
    url: "/api/companyInfo/update",
    method: "put",
    data: { data }
  });
};



